import { MoreVert } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useState } from "react";

import useService from "../../../../../hooks/useService";
import ModalShell from "../../../../global/ModalShell";
import PermissionWrapper from "../../../../global/PermissionWrapper";
import DocumentActions from "../../../../modules/Documents/ViewDocuments/components/DocumentActions";
import AssociateAppointments from "../../../../navigations/documents/AssociateAppointments";
import HNSColors from "../../../../ui library/HNSColors";

const DocumentsTableActions = ({
  setAnchorEl,
  setSelectedDoc,
  document,
  onDocumentUpdate,
  enableThreeDotMenu,
  canAddAssociation,
}) => {
  const [openAssociateAppointmentsModal, setOpenAssociateAppointmentsModal] = useState(false);
  const [isLaunchedFromAppointmentsTab, setIsLaunchedFromAppointmentsTab] = useState(false);
  const appointmentRepository = useService("repositories/appointment-repository");
  const caseRepository = useService("repositories/case-repository");
  const [appointments, setAppointments] = useState([]);
  const [next, setNext] = useState(undefined);

  const handleCloseAssociateAppointmentModal = () => {
    setOpenAssociateAppointmentsModal(false);
  };

  const handleMenuOpen = (event, doc) => {
    setAnchorEl(event.currentTarget);
    setSelectedDoc(doc);
  };

  const handleOpenAssociateAppointmentModal = async (doc, shouldOpen, nextPageUrl = null) => {
    try {
      if (doc) {
        const _case = await caseRepository.findRecord(doc.case);
        const queryParams = {
          ordering: "-appointment_date, -appointment_time",
          include_administered: true,
          provider: doc.provider,
          client: _case.client.id,
        };
        const params = new URLSearchParams(nextPageUrl);
        queryParams.limit = params.get("limit");
        queryParams.offset = params.get("offset");

        const appt = await appointmentRepository.query(queryParams);
        const nextPage = await appointmentRepository.getNextPage();
        setNext(nextPage);
        if (appt) {
          setAppointments(appt);
          setOpenAssociateAppointmentsModal(shouldOpen);
        }
      }
    } catch (error) {
      console.error("Error fetching appointments:", error);
    }
  };

  return (
    <>
      <div className="flex items-center justify-end">
        <PermissionWrapper permission={canAddAssociation}>
          <DocumentActions
            document={document}
            handleOpenAssociateAppointmentModal={handleOpenAssociateAppointmentModal}
            setIsLaunchedFromAppointmentsTab={setIsLaunchedFromAppointmentsTab}
          />
        </PermissionWrapper>
        <PermissionWrapper permission={enableThreeDotMenu}>
          <IconButton onClick={(e) => handleMenuOpen(e, document)} className="-ml-1">
            <MoreVert sx={{ color: HNSColors.primary[500] }} />
          </IconButton>
        </PermissionWrapper>
      </div>

      {appointments && appointments.length > 0 && (
        <ModalShell
          open={openAssociateAppointmentsModal}
          setOpen={handleCloseAssociateAppointmentModal}
          fullWidth
          customWidth="xl"
        >
          <AssociateAppointments
            document={document}
            setOpenAssociateAppointmentsModal={handleCloseAssociateAppointmentModal}
            appointments={appointments}
            isLaunchedFromAppointmentsTab={isLaunchedFromAppointmentsTab}
            selectedAppointment={null}
            nextPageUrl={next}
            handleOpenAssociateAppointmentModal={handleOpenAssociateAppointmentModal}
            onDocumentUpdate={onDocumentUpdate}
          />
        </ModalShell>
      )}
    </>
  );
};

export default DocumentsTableActions;
